import main from '@/data/main.js'
export default class ShopCourseService {
    private base_url = `${main.BASE_ENDPOINT}/lms_order/my-orders`

    public async getAllCoursesShop(token:string | null) {
        const uri = this.base_url
        const rawResponse = await fetch(uri,  {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
        const response = await rawResponse.json()
        return response
    }

}